import React from 'react';
import {
  BIG_MARGIN_VERTICAL_FN,
  isWeb,
} from '../../../config/designSystem/Layout';

import Show from '../../../components/Show/Show';
import { BOTTOM_SPACING_SCROLLVIEW, SPACING } from '../../../config/designSystem/Spacing';
import { FAQ } from '../../../components/FAQ/FAQ';
import { FlatList, View } from 'react-native';
import { HorizontalItem } from '../../../components/Library/HorizontalItem';
import { ICategoryModel } from '../../../state/stores/Category/CategoryModel';
import { TopNavigation } from '../../../components/TopNavigation/TopNavigation';
import { concatPath } from '../../../utils/links/concatPath';
import { libraryKey, privateKey } from '../../../constants/routeKeys';
import { observer } from 'mobx-react';
import { router, useLocalSearchParams } from 'expo-router';
import { useAvailableDimensions } from '../../../hooks/ui/useAvailableDimensions';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStores } from '../../../hooks/useStores';


type DashboardProps =  {
  id: string,
};


const GenericPage: React.FunctionComponent<DashboardProps> = observer(() => {
  const rootStore = useStores();
  const params = useLocalSearchParams();
  const id = params.id;
  const { width } = useAvailableDimensions();
  // const labels = rootStore?.language?.translate?.MOBILE?.SNACKING?.ASSESSMENT;
  const data = rootStore?.categories.getCategoriesItemsFormatedForGenericPage(id as string);

  const insets = useSafeAreaInsets();
  const category : ICategoryModel = rootStore?.categories.getCategory(id as string);



  const goToLibrary = () => {

    router.navigate(concatPath([privateKey, libraryKey ], -1) as string);
  };



  const renderDashboardItem = (item: any, index: number) => {
    if (item) {
      return (
        <View>
          <HorizontalItem
            id={item?.contentId}
            small={true}
            contentType={item.contentType}
            key={index}
            displayButtonBelow={false}
            showActivityType={category?.showCategoryItemsType}
          />
        </View>
      );
    } else {
      return;
    }
  };

  const renderCategory = ({ item }: any) => {
    const output = [];
    for (let i = 0; i < item.count; i++) {
      output.push(renderDashboardItem(item.data[i], i));
    }
    return (
      <View
        style={{
          flexDirection: 'row',
          justifyContent: isWeb ? 'space-evenly' : 'space-between',
          margin: SPACING['sp-16'],
          marginHorizontal: isWeb ? 4 * BIG_MARGIN_VERTICAL_FN(width) : SPACING['sp-24'],
        }}
      >
        {output}
      </View>
    );
  };



  return (
    <>
      <TopNavigation
        onboarding={false}
        topPosition={insets?.top + SPACING['sp-16']}
        onPressLeft={goToLibrary}
        title={category?.title}/>
      <Show when = {category?.infoVisible}>
        <View >
          {category?.infoVisible && <FAQ
            title={category.infoTitleGenericPage?category.infoTitleGenericPage:''}
            text={category.infoGenericPage?category.infoGenericPage:''}
            extraInfo= {{
              'categoryTitle' : category?.title? category.title: '',
              'categoryId' : category._id
            }
            }
          />}
        </View>
      </Show>

      {data && data.length > 0 && (
        <FlatList
          data={data}
          keyExtractor={(_item, index) => String(index)}
          renderItem={renderCategory}
          contentContainerStyle={{
            alignItems: 'center',
            marginBottom: BOTTOM_SPACING_SCROLLVIEW,
            marginHorizontal: isWeb ? SPACING['sp-10'] : 0
          }}
        />
      )}
    </>
  );
});

export default GenericPage;
